import { api, type YoutubeItem } from './api.ts';
import { t } from './i18n/index.ts';
import { closePlayer, openPlayback, type PlaybackTarget } from './player/player.ts';
import { el, mount } from './ui/dom.ts';
// Döngüsel içe aktarım (cards -> playback -> cards) bilinçli: her iki taraf da
// fonksiyon bildirimi kullanıyor, çağrı anında çözülüyor.
import { youtubeCard } from './ui/cards.ts';
import { currentPath, navigate, resolve } from './router.ts';
import { loadSession } from './state.ts';
// Döngüsel içe aktarım (browse -> playback -> browse); yalnız çağrı anında kullanılır.
import { refreshContinueShelf } from './views/browse.ts';

// Oynatıcıyı açan tek kapı. Kapanışta oturum bilgisi (kota!) tazelenir ve
// "kalan süre" ile "devam et" rafı oynatmadan hemen sonra doğru olur.

export async function play(target: Omit<PlaybackTarget, 'onRelated'>): Promise<void> {
  const back = currentPath();
  const full: PlaybackTarget = {
    ...target,
    onRelated: target.relatedQuery ? (host, close) => void renderRelated(target.relatedQuery!, host, close) : undefined,
  };
  await openPlayback(full, () => {
    // loadSession kabuğu (kalan süre göstergesi) kendisi tazeler. Ekranın tamamı
    // yeniden ÇİZİLMEZ: liste başa dönüyor, seçili kategori ve yüklenmiş sayfalar
    // kayboluyordu. Yalnız "kaldığınız yer"i gösteren yerler yenilenir.
    void loadSession().then(() => {
      const here = currentPath();
      if (here !== back) { navigate(back, true); return; }
      // Liste ve dizi detayı ilerlemeyi satır satır gösteriyor; kısa ekranlar.
      if (here === '/library' || here.startsWith('/series/')) { void resolve(); return; }
      refreshContinueShelf();
    });
  });
}

/**
 * "Şunu da izle": YouTube'un gerçek öneri grafiğine erişimimiz yok; aynı kanaldan
 * arayıp izlenen videoyu eleyerek yaklaşık bir liste kuruyoruz. Başlık da bunu
 * iddia etmiyor.
 */
async function renderRelated(
  query: { exclude: string; channel: string; title: string },
  host: HTMLElement,
  close: () => void,
): Promise<void> {
  mount(host,
    el('h2', {}, t('playback.related')),
    el('p', { style: { color: 'var(--ink-dim)' } }, t('playback.relatedSub')),
    el('div', { class: 'grid', id: 'related-grid' }),
    el('div', { style: { textAlign: 'center' } },
      el('button', { class: 'btn ghost', type: 'button', onClick: close }, t('playback.backToList'))),
  );
  const grid = host.querySelector('#related-grid') as HTMLElement;
  try {
    const params = new URLSearchParams({ exclude: query.exclude, channel: query.channel, title: query.title });
    const data = await api.get<{ items: YoutubeItem[] }>(`/api/catalog/youtube/related?${params}`);
    if (!data.items.length) {
      mount(grid, el('p', { style: { color: 'var(--ink-faint)' } }, t('playback.noRelated')));
      return;
    }
    mount(grid, ...data.items.map((item) => youtubeCard(item, { onPlay: () => closePlayer() })));
  } catch {
    mount(grid, el('p', { style: { color: 'var(--ink-faint)' } }, t('playback.relatedFail')));
  }
}
